const STORAGE_KEY = "digitair_offline_cred";

const hashPin = async (pin, crewCode) => {
    const data = new TextEncoder().encode(`${pin}:${crewCode}:digitair-sales`);
    const buf  = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const saveOfflineCredential = async (user, params, pin = null) => {
    const pinHash = pin ? await hashPin(pin, user.crewCode) : null;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
        user,
        params,
        crewCode: user.crewCode,
        crewName: user.crewName,
        pinHash,
        savedAt: new Date().toISOString(),
    }));
};

export const getOfflineCredential = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); }
    catch { return null; }
};

export const verifyOfflinePin = async (pin) => {
    const cred = getOfflineCredential();
    if (!cred) return false;
    const hash = await hashPin(pin, cred.crewCode);
    return hash === cred.pinHash;
};

export const clearOfflineCredential = () => localStorage.removeItem(STORAGE_KEY);

// Save the WebAuthn credential ID after a successful online biometric login
// so it can be used as allowCredentials hint for offline biometric auth
export const saveBiometricCredentialId = (credentialId) => {
    const cred = getOfflineCredential();
    if (!cred) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...cred,
        biometricCredentialId: credentialId,
    }));
};

// Refresh user + params in an existing credential (keeps existing PIN hash unchanged)
export const refreshOfflineCredential = (user, params) => {
    const cred = getOfflineCredential();
    if (!cred || cred.crewCode !== user.crewCode) return false;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...cred,
        user,
        params,
        savedAt: new Date().toISOString(),
    }));
    return true;
};
